import { ChartResponse } from '@/api/tax-guide';
import React, { useCallback } from 'react';
import { PieChart } from './PieChart';

interface RenderContentProps {
  htmlString: string;
  chartContents?: Array<ChartResponse>;
}

const RenderContent: React.FC<RenderContentProps> = ({
  htmlString,
  chartContents,
}) => {
  //utility to render chart in a separate div and then insert it into the div created by backend
  const renderChart = useCallback((divId: string): void => {
    const element = document.getElementById(divId);
    const generated = document.getElementById(`generated-chart-${divId}`);
    if (element && generated) {
      element.innerHTML = generated.innerHTML;
    }
  }, []);

  const chartResponse = chartContents;
  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: htmlString }} />
      {chartResponse && chartResponse.length > 0 && (
        <div style={{ display: 'none' }}>
          {chartResponse.map(chart => (
            <PieChart
              data={chart}
              onCompleteRender={() => {
                renderChart(chart.divId);
              }}
              key={chart.divId}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default RenderContent;
